<template>
  <div>
    <span class="dropdown-item">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><fa icon="search" /></span>
        </div>
        <input :placeholder="$t('search')" v-model="search" type="text" class="form-control">
      </div>
    </span>
    <slot />
  </div>
</template>

<style scoped>
.dropdown-menu {
  min-width: 300px;
}
</style>

<script>
export default {
  name: 'DropDownSearch',

  props: {
    id: { type: String, default: null },
    variant: { type: String, default: 'secondary' }
  },

  data: () => ({
    search: ''
  }),

  watch: {
    search: function (newV) {
      this.$emit('input', newV)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/DropDownSearch.vue